import schema from '@/framework/logic/schema/hide-layout-component.schema.json';
import interpolate from '@/framework/logic/shared/interpolate';
import { makeValidated } from '@/framework/logic/shared/utils';

import setLayoutProperty from './setLayoutProperty';

const mapHideLayoutComponent = action => ({
  type: 'setLayoutProperty',
  data: {
    path: `components.${action.data}.properties.visible`,
    value: false,
  },
});

const validated = makeValidated(schema);

const hideLayoutComponent = (context, event, meta) => {
  return setLayoutProperty(context, event, {
    action: mapHideLayoutComponent(
      validated(interpolate(meta.action, event, context))
    ),
  });
};

export default hideLayoutComponent;
